import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getPurposeList = (payload, callback) =>
  req.list(c.GET_PURPOSE, '/api/v1/administrators/purposes', payload, callback);

export const showPurpose = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_PURPOSE,
    `/api/v1/administrators/purposes/${id}`,
    payload,
    callback
  );

export const createPurpose = (payload, callback) =>
  req.create(
    c.CREATE_PURPOSE,
    '/api/v1/administrators/purposes',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updatePurpose = (id, payload, callback) =>
  req.update(
    c.UPDATE_PURPOSE,
    `/api/v1/administrators/purposes/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removePurpose = (id, payload, callback) =>
  req.remove(
    c.REMOVE_PURPOSE,
    `/api/v1/administrators/purposes/${id}`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Purpose removed!');
      if (callback) callback();
    }
  );

export const activatePurpose = (id, payload, callback) =>
  req.update(
    c.ACTIVATE_PURPOSE,
    `/api/v1/administrators/purposes/${id}/activate`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Purpose activated!');
      if (callback) callback();
    }
  );

export const deActivatePurpose = (id, payload, callback) =>
  req.update(
    c.DEACTIVATE_PURPOSE,
    `/api/v1/administrators/purposes/${id}/deactivate`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Purpose de-activated!');
      if (callback) callback();
    }
  );
